import React, { useEffect, useRef, useState } from "react";
import { Button, ProgressBar } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonservices } from "../../services/CommonServices";
import deleteIcon from "../../assets/images/deleteaction.svg";

const DropFileInput = (props) => {
  
  const wrapperRef = useRef(null);
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  
  const onDragEnter = () => wrapperRef.current.classList.add("dragover");
  const onDragLeave = () => wrapperRef.current.classList.remove("dragover");
  const onDrop = () => wrapperRef.current.classList.remove("dragover");
  const onFileDrop = (e) => {
    const newFile = e.target.files[0];
    if (newFile) {
      const fileExtension = newFile.name.split(".").pop().toLowerCase();

      if (fileExtension === "zip") {
        setFile(newFile);
        props.onFileChange(newFile);
      } else {
        toast.error("Please upload a ZIP file only.");
        setFile(null);
        props.onFileChange(null);
      }
    }
  };

  const fileRemove = () => {
    setFile(null);
    props.onFileChange(null);

    // if (fileInputRef) {
    fileInputRef.current = null;
    // }
  };
  useEffect(() => {
    if (props?.removefile) {
      setFile(null);
      props.onFileChange(null);
      fileInputRef.current = null;
    }
  }, [props?.removefile]);

  return (
    <div className="w-100">
      {file ? (
        <div className="drop-file-preview mt-0 w-100">
          <div className="drop-file-box  height-88">
            <div className="drop-file-preview__item">
              <div className="drop-file-preview__item__info">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.68227 0H17.7161L26.219 8.86259V26.099C26.219 28.2478 24.4668 30 22.318 30H7.68227C5.52427 30 3.78125 28.2478 3.78125 26.099V3.90102C3.78125 1.74302 5.52427 0 7.68227 0Z"
                      fill="#FFB11F"
                    />
                    <path
                      opacity="0.302"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M17.707 0V8.78882H26.2191L17.707 0Z"
                      fill="white"
                    />
                    <path
                      d="M12.0436 15.5857V13.5383C12.0436 13.317 11.8684 13.1418 11.6471 13.1418H10.5404C10.3191 13.1418 10.1438 13.317 10.1438 13.5383V15.5857L9.52593 17.3933C9.3507 17.9005 9.43371 18.4631 9.74726 18.8965C10.0516 19.3299 10.5588 19.5882 11.0937 19.5882C11.6286 19.5882 12.1266 19.3299 12.4402 18.8965C12.7537 18.4631 12.8367 17.9005 12.6615 17.3933L12.0436 15.5857ZM11.7854 18.4261C11.4719 18.878 10.7156 18.878 10.3929 18.4261C10.2361 18.2048 10.19 17.9097 10.2822 17.6515L10.4851 17.0428H11.6932L11.9053 17.6515C11.9883 17.9097 11.9514 18.2048 11.7854 18.4261ZM8.64062 2.14886V3.27399C8.64062 3.49532 8.81586 3.67055 9.03719 3.67055H10.5404V5.34902H9.03719C8.81586 5.34902 8.64062 5.52425 8.64062 5.74558V6.61247C8.64062 6.83379 8.81586 7.01824 9.03719 7.01824H10.5404V8.68746H9.03719C8.81586 8.68746 8.64062 8.86269 8.64062 9.08402V9.96012C8.64062 10.1814 8.81586 10.3567 9.03719 10.3567H10.5404V11.6293C10.5404 11.8507 10.7249 12.0259 10.9462 12.0259H13.1503C13.3624 12.0259 13.5469 11.8507 13.5469 11.6293V10.7532C13.5469 10.5411 13.3624 10.3567 13.1503 10.3567H11.6379V8.68746H13.1503C13.3624 8.68746 13.5469 8.51222 13.5469 8.2909V7.4148C13.5469 7.19347 13.3624 7.01824 13.1503 7.01824H11.6379V5.34902H13.1503C13.3624 5.34902 13.5469 5.16457 13.5469 4.94325V4.07636C13.5469 3.85504 13.3624 3.67059 13.1503 3.67059H11.6379V2.13965C11.6378 2.13965 8.64062 2.14886 8.64062 2.14886Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div>
                  <h6>{file.name}</h6>
                  <p>
                    {file?.size ? commonservices.FileSizeMBGB(file?.size) : 0}
                    {props?.uploadPercentage > 0 &&
                      `| ${props?.uploadPercentage}%`}
                  </p>
                </div>
              </div>
              <span
                className="drop-file-preview__item__del"
                onClick={fileRemove}
              >
                <img src={deleteIcon} alt="deleteIcon" />
              </span>
            </div>
            {props?.uploadPercentage > 0 && (
              <ProgressBar now={props?.uploadPercentage} />
            )}
          </div>
        </div>
      ) : (
        <div
          ref={wrapperRef}
          className="drop-file-input  height-88"
          onDragEnter={onDragEnter}
          onDragLeave={onDragLeave}
          onDrop={onDrop}
        >
          <div className="drop-file-input__label">
            <div>
              <h5>Drag 'n' drop file here</h5>
              <p>Only Zip File</p>
            </div>
            <Button className="blue-btn w-auto">Choose File</Button>
          </div>
          <input
            type="file"
            ref={fileInputRef}
            accept=".zip"
            onChange={onFileDrop}
          />
        </div>
      )}
    </div>
  );
};

export default DropFileInput;
